export default __webpack_public_path__ + "static/warehouse-presentation_kz-442eff8fd06a8892b7512ff400046db0.webp";